/**
 * Origin fence for the per-company public domains (spec §4). Entity domains
 * (app.pinkibeans.com / app.smartreno.com.sg) serve PUBLIC pages only; any
 * other path there bounces to the staff origin before the app renders — which
 * is why staff sign-in never happens on an entity domain and no Firebase Auth
 * authorized-domain change is needed. Pure decision logic; the one wiring
 * site is src/main.tsx. Browser-only — NOT in `shared/`.
 */
import { canonicalOriginFor } from '../../shared/quoteMessaging';

export const PUBLIC_PATH_PREFIXES = [
  '/quote/',
  '/schedule/',
  '/deliver/',
  '/approve-variation/',
] as const;

export const isPublicPath = (pathname: string): boolean =>
  PUBLIC_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));

/**
 * Full URL to bounce a non-public path off an entity origin, or null to stay.
 * `canonicalOriginFor(origin, undefined)` is the environment's WSS origin when
 * (and only when) `origin` is a known non-WSS origin — WSS origins are already
 * canonical (null) and unknown origins are never fenced (null).
 */
export const resolveStaffFenceRedirect = (
  origin: string,
  pathname: string,
  search: string,
): string | null => {
  if (isPublicPath(pathname)) return null;
  const wssOrigin = canonicalOriginFor(origin, undefined);
  if (!wssOrigin) return null;
  return `${wssOrigin}${pathname}${search}`;
};
